import { Radio, RadioGroup } from '@sbab-ui/components'
import { useRef } from 'react'
import { AppAction } from '../../appState'
import useRadioForm from '../../hooks/useRadioForm'
import FormWrapper from './FormWrapper'

interface Props {
  id: string
  value: string
  appDispatch: React.Dispatch<AppAction>
  label: string
  description?: string
  maxLength?: number
  step?: number
  placeholder?: string
  options: { id: number; label: string; value: string }[]
  validationFunction: (value: string) => string
  isFetching?: boolean
}

export default function FormWithRadio({
  id,
  value,
  appDispatch,
  label,
  step,
  options,
  description,
  validationFunction,
  isFetching = false,
}: Readonly<Props>) {
  const { inputRef, handledValue, errorMessage, hasBeenTouched, onChangeHandler, submitHandler } =
    useRadioForm({
      initialValue: value,
      appDispatch,
      id,
      validationFunction,
    })
  const submitButtonRef = useRef<HTMLButtonElement>(null)

  function handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      submitButtonRef.current?.click()
    }
  }

  const disabled = !!errorMessage || !hasBeenTouched
  const loading = isFetching

  return (
    <FormWrapper
      id={id}
      appDispatch={appDispatch}
      step={step}
      label={label}
      description={description}
      errorMessage={errorMessage}
      inputRef={inputRef}
      submitButtonRef={submitButtonRef}
      submitHandler={submitHandler}
      disabled={disabled}
      loading={loading}
    >
      <RadioGroup
        className="!w-full lg:!w-[500px]"
        aria-label="Radioknappar"
        name={id}
        onChange={onChangeHandler as (value: string) => void}
        value={handledValue ? handledValue.toString() : ''}
        onKeyPress={handleKeyPress}
      >
        <div className="flex md:flex-col lg:flex-row">
          {options.map((option, index) => (
            <label
              key={option.id}
              className="w-full border border-x-neutral-60 border-t-neutral-60 p-4 text-center lg:w-full"
              style={{
                border: 'bold',
                borderBottomWidth: '4px',
                borderBottomColor: value === option.value ? '#FF620F' : '#F2F2F2',
              }}
            >
              <Radio
                aria-label="Radioknappar"
                label={option.label}
                value={option.value}
                ref={index === 0 ? inputRef : undefined}
              />
            </label>
          ))}
        </div>
      </RadioGroup>
    </FormWrapper>
  )
}
